module.exports = __webpack_public_path__ + "img/fm_workflow_3.5e94b901.png";